import React, { Fragment, useState, useEffect } from 'react';
import Square from './Square';

const mockDays = {
  week: [
    { available: false, isoDayOfWeek: 1, weekdayAbbr: 'LU' },
    { available: false, isoDayOfWeek: 2, weekdayAbbr: 'MA' },
    { available: false, isoDayOfWeek: 3, weekdayAbbr: 'MI' },
    { available: false, isoDayOfWeek: 4, weekdayAbbr: 'JU' },
    { available: false, isoDayOfWeek: 5, weekdayAbbr: 'VI' },
  ],
  weekend: [
    { available: false, isoDayOfWeek: 6, weekdayAbbr: 'SA' },
    { available: false, isoDayOfWeek: 7, weekdayAbbr: 'DO' },
    { available: false, isoDayOfWeek: 8, weekdayAbbr: 'FES' },
  ],
};

function BusinessHoursSection(props) {
  const [isClosed, setIsClosed] = useState(false);
  const [days, setDays] = useState([]);

  useEffect(() => {
    !props.days.length ? setDays(mockDays[props.id]) : setDays(props.days);
    let closedDays = [];
    if (props.days.length) {
      closedDays = props.days.filter((businessHour) => {
        return !businessHour.available;
      });
    }
    closedDays.length === props.days.length
      ? setIsClosed(true)
      : setIsClosed(false);
  }, [props.days, props.id]);

  return (
    <Fragment>
      <div key={props.id} className="row px-0 mx-0 mb-4 pt-0">
        <div className="d-flex flex-column w-100">
          <h5>
            <strong>{props.title}</strong>
          </h5>
          <div className="d-flex flex-wrap justify-content-center justify-content-md-between">
            <div className="d-flex flex-wrap justify-content-center justify-content-md-start">
              {days.map((businessHour, index) => (
                <Square
                  key={index}
                  isFirst={index === 0}
                  condition={businessHour.available}
                  text={businessHour.weekdayAbbr}
                ></Square>
              ))}
            </div>
            <span
              className={
                'border rounded align-self-center mr-2 my-2 p-2 business-hours-section ' +
                (isClosed ? 'closed' : 'border-dark')
              }
            >
              <h5 className="m-0 mx-2">
                <strong>
                  {isClosed
                    ? 'Cerrado'
                    : props.startHour + ' a ' + props.endHour + ' hrs.'}
                </strong>
              </h5>
            </span>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default BusinessHoursSection;
